import { render, staticRenderFns } from "./commonAccidentListCom.vue?vue&type=template&id=7983310a"
import script from "./commonAccidentListCom.vue?vue&type=script&lang=js"
export * from "./commonAccidentListCom.vue?vue&type=script&lang=js"
import style0 from "./commonAccidentListCom.vue?vue&type=style&index=0&id=7983310a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports